var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tabs-items', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_vm._t("default", null, null, {
    tabs: _vm.tabs,
    tab: _vm.tab,
    prev: _vm.prev,
    next: _vm.next
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }